module.exports = __webpack_public_path__ + "static/img/office.dc509cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/office.jpg
// module id = RrJv
// module chunks = 1